import GenericFilter from "./GenericFilter";
import { INDUSTRY_COLOR_MAP } from "../../../lib/constants";
import type { Filters, FilterOptions, UpdateFilterFn, ToggleArrayFilterFn } from "../types";

type Props = {
  filters: Filters;
  filterOptions: FilterOptions;
  updateFilter: UpdateFilterFn;
  toggleArrayFilter: ToggleArrayFilterFn;
  isMobile: boolean;
  isActive: boolean;
};

const IndustryFilters = ({
  filters,
  filterOptions,
  updateFilter,
  toggleArrayFilter,
  isMobile,
  isActive,
}: Props) => {
  return (
    <GenericFilter
      filterKey="industries"
      selectedValues={filters.industries}
      availableValues={filterOptions.industries ?? []}
      colorMap={INDUSTRY_COLOR_MAP}
      updateFilter={updateFilter}
      toggleArrayFilter={toggleArrayFilter}
      isMobile={isMobile}
      isActive={isActive}
      radioName="industry-radio"
    />
  );
};

export default IndustryFilters;
